var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareLink = function SvgShareLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#080808",
    fillRule: "evenodd",
    d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16m12.2 6.699A2.05 2.05 0 1 1 9.3 19.8l4.243-4.243c.8-.8 2.098-.8 2.899 0a.95.95 0 0 0 1.343-1.343 3.95 3.95 0 0 0-5.585 0l-4.243 4.243a3.95 3.95 0 1 0 5.586 5.585l2.121-2.12a.95.95 0 0 0-1.343-1.344zM24.043 7.957a3.95 3.95 0 0 0-5.587 0l-2.544 2.545a.95.95 0 0 0 1.343 1.343L19.8 9.3a2.05 2.05 0 0 1 2.9 2.899l-4.667 4.667c-.801.8-2.099.8-2.899 0a.95.95 0 1 0-1.344 1.343 3.95 3.95 0 0 0 5.586 0l4.667-4.667a3.95 3.95 0 0 0 0-5.585",
    clipRule: "evenodd"
  })));
};
export default SvgShareLink;